import { useState, useEffect } from "react";
import "../../app.css";
import Hero from "@/components/hero/hero";
import Team from "@/components/team/team";
import Chart from "@/components/chart/chart";
import Blog from "@/components/blog/blog";
import Community from "@/components/community/community";
import Featured from "@/components/featured/featured";


function Home() {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	
	return (
		<div className="App">
			<hr />
			<Hero />
			<Team />
			<Chart />
			<Blog />
			<Featured />
			<Community />
			<hr />
		</div>
	)
}

export default Home;
